import React from 'react'

export const ICON_COLORS = {
  WHITE: '#ffffff',
  BLACK: '#000000',
  TEAL: '#01b4b4',
  TEAL_DARK: '#007172',
  BLUE: '#5c738a',
  BLUE_DARK: '#44576b',
  GRAY_DARK: '#4a4a4a',
}

function getIconClassNames (props) {
  const { className } = props
  const baseClassName = 'icon'
  const baseClassNameArray = [baseClassName]

  if (className) {
    baseClassNameArray.push(className)
  }

  return baseClassNameArray.join(' ')
}

function getIconStyles (props) {
  const { size } = props

  return {
    width: size,
    height: size,
  }
}

/**
 * SVG based Icon component
 * @param {Object} props - The props
 * @param {Number} props.size - The size of the icon in pixels
 * @param {String} props.color - The color of the icon
 * @param {JSX.Element} props.children - The individual child icon component
 * @returns {JSX.Element} A formatted SVG based Icon
 */
function Icon (props) {
  const {
    size = 24,
    color = 'currentColor',
    children,
  } = props
  const sizeInPx = typeof size === 'string' && size.endsWith('px') ? size : `${size}px`

  return (
    <span
      className={getIconClassNames(props)}
      style={getIconStyles({ size: sizeInPx })}
      role="presentation"
    >
      {
        // pass props down to the children, merging with existing props
        React.cloneElement(children, { ...children.props, size: sizeInPx, color })
      }
    </span>
  )
}

export default Icon
